module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2"
  }, [_c('a', {
    attrs: {
      "id": "page_vii"
    }
  }), _c('em', [_vm._v("Contents")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/html/9780230337411_08_map#map"
    }
  }, [_c('em', [_vm._v("Maps")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocb"
  }, [_c('a', {
    attrs: {
      "href": "#/html/9780230337411_09_pre#pre"
    }
  }, [_c('em', [_vm._v("Preface: Beneath the Hat")])])]), _vm._v(" "), _c('table', [_c('tbody', [_c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/html/9780230337411_10_int#int"
    }
  }, [_vm._v("Introduction")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/html/9780230337411_10_int#int"
    }
  }, [_vm._v("The Last City of the Incas: The Sixteenth-Century Conquest")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "2",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc-part"
  }, [_c('a', {
    attrs: {
      "href": "#/html/9780230337411_11_pt1#pt1"
    }
  }, [_vm._v("Part One"), _c('br'), _vm._v("The Explorer")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/html/9780230337411_12_ch1#ch1"
    }
  }, [_vm._v("Chapter One")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/html/9780230337411_12_ch1#ch1"
    }
  }, [_vm._v("The Black Temple")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/html/9780230337411_13_ch2#ch2"
    }
  }, [_vm._v("Chapter Two")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/html/9780230337411_13_ch2#ch2"
    }
  }, [_vm._v("The Ivory Tower")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/html/9780230337411_14_ch3#ch3"
    }
  }, [_vm._v("Chapter Three")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/html/9780230337411_14_ch3#ch3"
    }
  }, [_vm._v("The Compass")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/html/9780230337411_15_ch4#ch4"
    }
  }, [_vm._v("Chapter Four")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/html/9780230337411_15_ch4#ch4"
    }
  }, [_vm._v("Into the Andes")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780230337411_16_ch5#ch5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Five")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780230337411_16_ch5#ch5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cuzco, the Navel of the World")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780230337411_17_ch6#ch6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Six")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780230337411_17_ch6#ch6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Choqquequirau, the Cradle of Gold")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "2",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780230337411_18_ch6bm#pt1int",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Interlude: Manco Inca")])])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "2",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc-part"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780230337411_19_pt2#pt2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Part Two"), _c('br'), _vm._v("The Search")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780230337411_20_ch7#ch7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Seven")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780230337411_20_ch7#ch7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Best Laid Plans")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780230337411_21_ch8#ch8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Eight")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780230337411_21_ch8#ch8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Dead Man’s Gulch")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780230337411_22_ch9#ch9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Nine")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780230337411_22_ch9#ch9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Discoverers of Machu Picchu")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780230337411_23_ch10#ch10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Ten")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780230337411_23_ch10#ch10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The White Temple")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "id": "page_viii"
    }
  }), _c('span', {
    attrs: {
      "href": "#/html/9780230337411_24_ch11#ch11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Eleven")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780230337411_24_ch11#ch11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Plain of Ghosts")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "2",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780230337411_25_ch11bm#pt2int",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Interlude: Titu Cusi")])])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "2",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc-part"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780230337411_26_pt3#pt3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Part Three"), _c('br'), _vm._v("The Resurrectionists")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780230337411_27_ch12#ch12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Twelve")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780230337411_27_ch12#ch12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Deal")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780230337411_28_ch13#ch13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Thirteen")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780230337411_28_ch13#ch13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Cemetery of the Incas")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780230337411_29_ch14#ch14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Fourteen")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780230337411_29_ch14#ch14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Debate")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780230337411_30_ch15#ch15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Fifteen")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780230337411_30_ch15#ch15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Prize")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "2",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780230337411_31_ch15bm#pt3int",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Interlude: Tupac Amaru")])])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "2",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc-part"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780230337411_32_pt4#pt4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Part Four"), _c('br'), _vm._v("Bonesmen")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780230337411_33_ch16#ch16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Sixteen")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780230337411_33_ch16#ch16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Between the Poles")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780230337411_34_ch17#ch17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Seventeen")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780230337411_34_ch17#ch17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Temptation")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780230337411_35_ch18#ch18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Eighteen")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780230337411_35_ch18#ch18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Roads to Ruins")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780230337411_36_ch19#ch19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Nineteen")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780230337411_36_ch19#ch19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Trial of Hiram Bingham")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780230337411_37_ch20#ch20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Twenty")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780230337411_37_ch20#ch20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Airborne")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "2",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780230337411_38_bm1#ret",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Returns")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "2",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780230337411_39_bm2#epi",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Epilogue")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "2",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780230337411_40_bm3#aft",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Afterword")])])])])])]), _vm._v(" "), _c('p', {
    staticClass: "toct"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780230337411_41_bm4#ack",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Acknowledgments")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780230337411_42_bm5#sou",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("A Note on Sources")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780230337411_43_bm6#not",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Notes")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780230337411_44_bm7#ind",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Index")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1c356b3b","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/html/9780230337411_07_toc.vue
// module id = 75
// module chunks = 0